﻿import mixitup from 'mixitup';
import mixitupMultiFilter from './mixitup-multifilter.min.js';

mixitup.use(mixitupMultiFilter);

export const initEmployeesFilters = () => {
  const filterContainer = document.querySelector(
    '.filter-container',
  ) as HTMLDivElement;

  const locationQuery = filterContainer
    .getAttribute('data-location-query')
    .toLowerCase();
  const areaQuery = filterContainer
    .getAttribute('data-area-query')
    .toLowerCase();

  let loadFilter = '';

  if (locationQuery.length > 0) {
    loadFilter += `[data-location~=${locationQuery}]`;
    const selector = document.querySelector(`#${locationQuery}`);
    if (selector) {
      selectElement(
        'location-filter-select',
        `[data-location~=${locationQuery}]`,
      );
    }
  }
  if (areaQuery.length > 0) {
    loadFilter += `[data-area~=${areaQuery}]`;
    const selector = document.querySelector(`#${areaQuery}`);
    if (selector) {
      selectElement('area-filter-select', `[data-area~=${areaQuery}]`);
    }
  }
  if (loadFilter.length === 0) {
    loadFilter = '.mix';
  }

  const mixer = mixitup('.employees', {
    selectors: {
      target: '.employee',
    },
    load: {
      filter: loadFilter,
    },
    multifilter: {
      enable: true,
    },
  });
};

const selectElement = (id: string, valueToSelect: string) => {
  const element = document.getElementById(id) as HTMLSelectElement;
  element.value = valueToSelect;
};
